<p-panel>
  <app-reactive-form-builder 
    (formChanges)="formChanges($event[0], $event[1])" 
    (goBack)="goBack()"
    [form]="form.formFields" 
    [serverUrl]="form.env.auxServerUrl"
    [dropdownLoadTrigger]="dropdownLoadTrigger" 
    [id]="(getModel().id)?.toString() ?? ''"
    [request]="this.getType() === 1 ? this.tareasApi.fertirrigacion.PUT : this.tareasApi.fertirrigacion.POST"
    [getRequest]="this.tareasApi.fertirrigacion.GET">
  </app-reactive-form-builder>
</p-panel>

<p-dialog
  [(visible)]="form.openDialog"
  [modal]="true"
  [dismissableMask]="true"
  header="Añadir valor"
  [style]="{ width: '28rem' }"
>
  <div [formGroup]="comunidadForm" class="p-fluid">
    <div class="field">
      <label for="nombre">Nombre</label>
      <input
        id="nombre"
        pInputText
        formControlName="nombre"
      />
      <small
        *ngIf="comunidadForm.controls['nombre']?.invalid && comunidadForm.controls['nombre']?.touched"
        class="p-error"
      >
        Campo requerido
      </small>
    </div>
  </div>
  <ng-template pTemplate="footer">
    <button pButton type="button" class="p-button-text" (click)="form.openDialog = false" label="Cancelar"></button>
    <button pButton type="button" (click)="saveNewOption()" label="Añadir" icon="pi pi-check"></button>
  </ng-template>
</p-dialog>